/**
 * @author      matthew@zumper.com (Matthew Talamini)
 * @copyright   Copyright (c) 2021, Zumper
 * @description router/listItem selectors
 */

import type { RouteComponentProps } from '@zcode/router-utils'

export const selectCityFromRouteProps = (
  routeProps: RouteComponentProps<{ locationPath: string }>
) => {
  return routeProps.match.params?.locationPath?.split('/')?.[1]
}
export const selectNeighborhoodFromRouteProps = (
  routeProps: RouteComponentProps<{ locationPath: string }>
) => {
  return routeProps.match.params?.locationPath?.split('/')?.[2]
}

export * from './propertyType'
